/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-extend-native */
/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

if (!Array.prototype.at) {
  console.error('Array.prototype not found, polyfilling');

  Array.prototype.at = function (index) {
    if (index >= 0) {
      return this[index];
    } else {
      return this[this.length + index];
    }
  };
}
